export enum LearningDirectoryType {
    Default = "Default",
    ValidSet = "ValidSet",
    StaticAnalysis = "StaticAnalysis",
    UserLevelAssessment = "UserLevelAssessment",
    UserProSkillAssure = "UserProSkillAssure",
    UserContest = "UserContest",
    UserLearning = "UserLearning",
}

export type UserLearningDirectoryTypes =
    | LearningDirectoryType.UserLevelAssessment
    | LearningDirectoryType.UserProSkillAssure
    | LearningDirectoryType.UserContest
    | LearningDirectoryType.UserLearning;

export default LearningDirectoryType;
